import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'

export interface IEnseigneConfig {
  ad2cp_on: boolean
  ais_on: boolean
  ais_anticollision_on: boolean
  postprocess_image: boolean
  // Modules par enseigne (BLF037, RG-ACC-047..053) : Gestion de flotte, Smart Planning, et leurs
  // options Couverture (seulement avec Smart Planning) et Formation.
  fleet_on: boolean
  smartplanning_on: boolean
  coverage_on: boolean
  formation_on: boolean
}

// Valeurs d'une clé absente du JSON : tout désactivé, sauf Smart Planning (RG-ACC-048).
export function getDefaultEnseigneConfig() {
  return {
    ad2cp_on: false,
    ais_on: false,
    ais_anticollision_on: false,
    postprocess_image: false,
    fleet_on: false,
    smartplanning_on: true,
    coverage_on: false,
    formation_on: false,
  } as IEnseigneConfig
}

export interface IAloDbEnseigneConstParam extends IAloDbBaseConstParam {
  ENS_ID: number | null
  ENS_KEY: string | null
  ENS_LIBELLE: string | null
  ENS_DATADD: string | null
  ENS_CONFIG_JSON: string | null
  ENS_ADCP_ON: boolean | null
}

export class AloDbEnseigne extends AloDbBase {
  public ENS_ID: number | null
  public ENS_KEY: string | null
  public ENS_LIBELLE: string | null
  public ENS_DATADD: Date | null
  public ENS_CONFIG_JSON: string | null
  public ENS_ADCP_ON: boolean | null
  public config: IEnseigneConfig

  constructor(
    {
      ENS_ID,
      ENS_KEY,
      ENS_LIBELLE,
      ENS_DATADD,
      ENS_ADCP_ON,
      ENS_CONFIG_JSON,
      ...args
    }: IAloDbEnseigneConstParam = {} as IAloDbEnseigneConstParam,
  ) {
    super(args)
    this.ENS_ID = ENS_ID
    this.ENS_KEY = ENS_KEY
    this.ENS_LIBELLE = ENS_LIBELLE
    this.ENS_DATADD = ENS_DATADD === null ? null : new Date(ENS_DATADD)
    this.ENS_ADCP_ON = ENS_ADCP_ON
    this.ENS_CONFIG_JSON = ENS_CONFIG_JSON
    this.config = {
      ...getDefaultEnseigneConfig(),
      ...{ ad2cp_on: ENS_ADCP_ON ?? false },
      ...JSON.parse(ENS_CONFIG_JSON ?? '{}'),
    } as IEnseigneConfig
  }

  static createAloDbEnseigneArray(datas: any) {
    return new AloBaseArray(AloDbEnseigne, datas)
  }

  static createAloDbEnseigneWithDetail(data: any) {
    return new AloDbEnseigne({ ...data, detailLoaded: true })
  }
}
